import { render } from "./AddressDetails.vue?vue&type=template&id=1e15e5af&scoped=true&ts=true"
import script from "./AddressDetails.vue?vue&type=script&lang=ts"
export * from "./AddressDetails.vue?vue&type=script&lang=ts"

import "./AddressDetails.vue?vue&type=style&index=0&id=1e15e5af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e15e5af"]])

export default __exports__